import building from 'plugins/i18n/entity/building.de.ts'

const role = {
	name: 'Personenfunktion | Personenfunktionen',
	fields: {
		name: 'Funktion',
		hp_id: 'ID',
		em: 'Typ',
		persons_count: 'Anzahl',
		building: {
			hp_id: 'Liegenschaft',
		},
		unit: {
			hp_id: 'Einheit',
		},
		role: {
			hp_id: 'Art',
		},
		started_at: 'Von',
		ended_at: 'Bis',
	},
}

export default role
